module.exports = __webpack_public_path__ + "static/media/work_london_sport.097381bb.jpg";